import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context';
import { getDefaultLandingPath } from '../../utils/defaultLanding';

export const LandingRedirect: React.FC = () => {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="protected-route-loading">
        <div className="protected-route-loading__spinner" />
      </div>
    );
  }

  return <Navigate to={getDefaultLandingPath()} replace />;
};

export default LandingRedirect;
